import React from "react";
import { Row, Col, Tag, Typography, Divider, Table } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import THEME from "../theme";
import { formatMoney, formatDate } from "../utils";
import StyledCard from "../components/StyledCard";

const { Text } = Typography;

const PaymentInCaseTab = ({ judgeData }) => {
  console.log("judgeData?.work_expense_list?");

  // if (
  //   !judgeData?.work_expense_list?.length ||
  //   !judgeData?.work_expense_list ||
  //   !judgeData?.judge ||
  //   !judgeData?.judge?.length
  // )
  //   return <Empty description="ไม่มีข้อมูล" />;
  return (
    <>
      {judgeData?.work_expense_list?.length > 0 && (
        <Row style={{ marginBottom: 16 }}>
          <Col span={24}>
            <StyledCard
              title="ตารางค่าใช้จ่ายในคดี"
              icon={
                <DollarOutlined
                  style={{ color: THEME.warning, fontSize: 18 }}
                />
              }
              style={{ height: "100%" }}
            >
              <Table
                dataSource={judgeData.work_expense_list}
                columns={[
                  {
                    title: "#",
                    key: "index",
                    width: 10,
                    align: "center",
                    render: (_, __, idx) => idx + 1,
                  },
                  {
                    title: "เลขที่ใบเสร็จ",
                    dataIndex: "TMBILL",
                    key: "TMBILL",
                    width: 60,
                    render: (val) => (
                      <Text style={{ fontFamily: "monospace", fontSize: 14 }}>
                        {val || "-"}
                      </Text>
                    ),
                  },
                  {
                    title: "รายการ",
                    dataIndex: "description",
                    key: "description",
                    width: 80,
                    render: (val) => <Text>{val || "-"}</Text>,
                  },
                  {
                    title: "จำนวนเงินเบิก",
                    dataIndex: "NETPAY",
                    key: "NETPAY",
                    width: 40,
                    align: "right",
                    render: (val) => (
                      <Text strong style={{ color: THEME.success }}>
                        {formatMoney(val)}
                      </Text>
                    ),
                  },
                  {
                    title: "จำนวนเงินจ่ายจริง",
                    dataIndex: "PAY",
                    key: "PAY",
                    width: 40,
                    align: "right",
                    render: (val) => (
                      <Text
                        style={{ color: val ? THEME.success : THEME.danger }}
                      >
                        {val ? formatMoney(val) : "-"}
                      </Text>
                    ),
                  },
                  {
                    title: "วันที่ชำระ",
                    dataIndex: "PAYDT",
                    key: "PAYDT",
                    width: 50,
                    align: "center",
                    render: (val) => (
                      <Text>
                        {val ? (
                          formatDate(val)
                        ) : (
                          <Tag color="orange">ยังไม่ชำระ</Tag>
                        )}
                      </Text>
                    ),
                  },
                  {
                    title: "สถานะ",
                    dataIndex: "FLAG",
                    key: "FLAG",
                    width: 40,
                    align: "center",
                    render: (val, record) => {
                      if (val === "C") return <Tag color="red">ยกเลิก</Tag>;
                      if (record.PAYDT)
                        return <Tag color="green">เคลียร์แล้ว</Tag>;
                      return <Tag color="orange">รอเคลียร์</Tag>;
                    },
                  },
                ]}
                rowKey="id"
                pagination={false}
                size="small"
                summary={() => {
                  const totalNetpay = judgeData.work_expense_list
                    .filter((r) => r.FLAG !== "C")
                    .reduce((sum, r) => sum + Number(r.NETPAY || 0), 0);

                  const totalPaid = judgeData.work_expense_list
                    .filter((r) => r.FLAG !== "C")
                    .reduce((sum, r) => sum + Number(r.PAY || 0), 0);

                  return (
                    <Table.Summary.Row style={{ background: THEME.light }}>
                      <Table.Summary.Cell colSpan={3}>
                        <Text strong>รวมทั้งหมด</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        <Text strong style={{ color: THEME.success }}>
                          {formatMoney(totalNetpay)}
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        <Text strong style={{ color: THEME.success }}>
                          {formatMoney(totalPaid)}
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell colSpan={2} />
                    </Table.Summary.Row>
                  );
                }}
              />
            </StyledCard>
          </Col>
        </Row>
      )}
      {judgeData?.judge?.length > 0 && (
        <>
          <Divider style={{ margin: "12px 0" }}>ยอดศาลสั่งจ่าย</Divider>
          <Row gutter={[12, 12]} style={{ marginLeft: 8, marginTop: 8 }}>
            {[
              {
                label: "ยอดชดใช้แทน",
                value: formatMoney(judgeData?.judge?.[0]?.judgement),
                color: THEME.danger,
                icon: "💰",
              },
              {
                label: "ค่าขาดประโยชน์",
                value: formatMoney(judgeData?.judge?.[0]?.lackOfBenefits),
                color: THEME.primary,
                icon: "📉",
              },

              {
                label: "ค่าขาดประโยชน์รายเดือน",
                value: formatMoney(
                  judgeData?.judge?.[0]?.costOfUselesenessPerMonth,
                ),
                color: THEME.warning,
                icon: "📆",
              },
              {
                label: "ค่าติดตาม",
                value: formatMoney(judgeData?.judge?.[0]?.trackingFee),
                color: THEME.primary,
                icon: "🔍",
              },
              {
                label: "ระยะเวลาค่าขาดประโยชน์",
                value: judgeData?.judge?.[0]?.costOfUselesenessMonth,
                color: THEME.warning,
                icon: "📆",
              },
              {
                label: "ค่าทนาย",
                value: formatMoney(judgeData?.judge?.[0]?.attorneyFees),
                color: THEME.primary,
                icon: "⚖️",
              },
              {
                label: "ค่าธรรมเนียม",
                value: formatMoney(judgeData?.judge?.[0]?.fee),
                color: THEME.primary,
                icon: "🧾",
              },
              {
                label: "รวมที่ต้องชำระ",
                value: formatMoney(judgeData?.judge?.[0]?.totalJugde),
                color: THEME.danger,
                icon: "💳",
              },
            ].map(({ label, value, color, icon }) => (
              <Col span={12} key={label}>
                <div
                  style={{
                    background: "#fff",
                    border: "1px solid #f0f0f0",
                    borderRadius: 8,
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <span style={{ fontSize: 18 }}>{icon}</span>
                  <div>
                    <Text
                      type="secondary"
                      style={{ fontSize: 16, display: "block" }}
                    >
                      {label}
                    </Text>
                    <Text strong style={{ color, fontSize: 18 }}>
                      {value}{" "}
                      <span
                        style={{
                          color: "#aaa",
                          fontWeight: 400,
                          fontSize: 12,
                        }}
                      >
                        {value ===
                        judgeData?.judge?.[0]?.costOfUselesenessMonth
                          ? "เดือน"
                          : "บาท"}
                      </span>
                    </Text>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <Divider style={{ margin: "12px 0" }} />
        </>
      )}
    </>
  );
};

export default PaymentInCaseTab;
